// La Casita de Dios brand tokens — ported from the Claude design.
export const C = {
  red: '#c1272d',
  blue: '#1b4f9c',
  navy: '#15233f',
  ink: '#15233f',
  body: '#3f3a33',
  muted: '#8a8175',
  muted2: '#6f675b',
  sand: '#faf6ef',
  sand2: '#f1e9da',
  gold: '#d4a017',
  goldSoft: '#e7c07a',
  line: '#ece2cf',
  footer: '#0f1930',
} as const

export const FONT = {
  serif: "'Spectral', Georgia, serif",
  sans: "'Mulish', system-ui, -apple-system, sans-serif",
} as const

// Brand colors for each social network (used by the rail + pills).
export const SOCIAL = {
  instagram: '#E1306C',
  facebook: '#1877F2',
  youtube: '#FF0000',
  whatsapp: '#25D366',
} as const
